import { useEffect, useState } from 'react'
import { useLoadingState } from '../../../contexts/loadingContext'
import styles from './routeLoadingBar.module.css'

export const RouteLoadingBar: React.FC = () => {
  const [progress, setProgress] = useState(0)
  const { isLoading } = useLoadingState()

  useEffect(() => {
    if (!isLoading) {
      setProgress(100)
      const timer = setTimeout(() => setProgress(0), 200)
      return () => clearTimeout(timer)
    }

    setProgress(0)
    const progressTimer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 90) {
          return 90
        }
        const diff = Math.random() * 20
        return Math.min(oldProgress + diff, 90)
      })
    }, 200)

    return () => clearInterval(progressTimer)
  }, [isLoading])

  if (!isLoading && progress === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      <div 
        className={styles.bar} 
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}
